import apiClient from './api/client';
import ENDPOINTS from './api/endpoints';

export const tableService = {
  
  getAllTables: async () => {
    try {
      return await apiClient.get(ENDPOINTS.TABLES.GET_ALL);
    } catch (error) {
      console.error('Failed to fetch tables:', error);
      throw error;
    }
  },

 
  getTableById: async (id) => {
    try {
      return await apiClient.get(ENDPOINTS.TABLES.GET_BY_ID(id));
    } catch (error) {
      console.error(`Failed to fetch table ${id}:`, error);
      throw error;
    }
  },

  
  createTable: async (tableData) => {
    try {
      return await apiClient.post(ENDPOINTS.TABLES.CREATE, tableData);
    } catch (error) {
      console.error('Failed to create table:', error);
      throw error;
    }
  },

 
  updateTable: async (id, updateData) => {
    try {
      return await apiClient.put(ENDPOINTS.TABLES.UPDATE(id), updateData);
    } catch (error) {
      console.error(`Failed to update table ${id}:`, error);
      throw error;
    }
  },

 
  deleteTable: async (id) => {
    try {
      return await apiClient.delete(ENDPOINTS.TABLES.DELETE(id));
    } catch (error) {
      console.error(`Failed to delete table ${id}:`, error);
      throw error;
    }
  },

  
  activateTable: async (id) => {
    try {
      return await apiClient.put(ENDPOINTS.TABLES.ACTIVATE(id));
    } catch (error) {
      console.error(`Failed to activate table ${id}:`, error);
      throw error;
    }
  },

  
  deactivateTable: async (id) => {
    try {
      return await apiClient.put(ENDPOINTS.TABLES.DEACTIVATE(id));
    } catch (error) {
      console.error(`Failed to deactivate table ${id}:`, error);
      throw error;
    }
  },

  /**
   * Merge tables - Create a new merged table group or add tables to existing order
   *
   * @param {Object} mergeData
   * @param {number} mergeData.masterTableId - The main table ID
   * @param {number[]} mergeData.mergedTableIds - Array of table IDs to merge with master
   * @param {string} [mergeData.splitName] - Split name (for occupied tables)
   * @param {number} [mergeData.peopleCount] - Number of people (for new groups)
   * @returns {Promise} API response with TableSplitDTO
   */
  mergeTables: async (mergeData) => {
    try {
      return await apiClient.post(ENDPOINTS.TABLE_SPLITS.MERGE, mergeData);
    } catch (error) {
      console.error('Failed to merge tables:', error);
      throw error;
    }
  },

  /**
   * Unmerge tables - Release merged tables back to available status
   *
   * @param {number} tableId - The master table ID
   * @param {string} splitName - The split name
   * @returns {Promise} API response
   */
  unmergeTables: async (tableId, splitName) => {
    try {
      return await apiClient.post(ENDPOINTS.TABLE_SPLITS.UNMERGE(tableId, splitName));
    } catch (error) {
      console.error('Failed to unmerge tables:', error);
      throw error;
    }
  },

  /**
   * Add more tables to an existing merge
   *
   * @param {Object} data
   * @param {number} data.masterTableId - The master table ID
   * @param {string} data.splitName - The split name
   * @param {number[]} data.additionalTableIds - Additional table IDs to add
   * @returns {Promise} API response with updated TableSplitDTO
   */
  addTablesToMerge: async (data) => {
    try {
      return await apiClient.post(ENDPOINTS.TABLE_SPLITS.ADD_TO_MERGE, data);
    } catch (error) {
      console.error('Failed to add tables to merge:', error);
      throw error;
    }
  },
};

export default tableService;
